import { COLOR } from '@/libs/core/constants'
import {
  PageBreak,
  Paragraph,
  TextRun,
  Table,
  TableRow,
  TableCell,
  WidthType,
  BorderStyle,
  VerticalAlign,
} from 'docx'
import { tableWidthDxa } from '../../constants'
import { pixelToDxa } from '@/libs/utils/docxUtils'
import { parseDateToTaiwanDate } from '../../../ReportPDF/TaiwanDateConvert'

const Row = ({ label, value, color = 'FFFFFF' }) =>
  new TableRow({
    height: { value: pixelToDxa(40) },
    children: [
      new TableCell({
        verticalAlign: VerticalAlign.CENTER,
        shading: { fill: color },
        children: [new Paragraph({ children: label })],
        borders: {
          top: { size: 1, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
          right: { size: 0, style: BorderStyle.NONE, color },
          left: { size: 1, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
          bottom: { size: 1, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
        },
      }),
      new TableCell({
        verticalAlign: VerticalAlign.CENTER,
        shading: { fill: color },
        children: [new Paragraph({ children: value })],
        borders: {
          top: { size: 1, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
          right: { size: 1, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
          left: { size: 0, style: BorderStyle.NONE, color },
          bottom: { size: 1, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
        },
      }),
    ],
  })

const DisclaimerPage = ({ reportData }) => {
  const {
    reprotDao,
    // primaryCompanyNickname,
    secondaryCompanyNickname,
    secondaryCompanyFullname,
    phishType,
    generateStartDate,
    generateEndDate,
  } = reportData || {}
  const { companyName, version } = reprotDao || {}
  const service = phishType

  return [
    new Paragraph({ children: [new PageBreak()] }),
    new Paragraph(''),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '法律聲明',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
          bold: true,
        }),
      ],
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: ' ',
          size: 24,
        }),
      ],
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '本文件內含機密及版權所有的資訊，僅供',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: companyName,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '使用。嚴禁未經授權者使用或複製本文件。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: ' ',
          size: 24,
        }),
      ],
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '本測試是由',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: secondaryCompanyNickname,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '的資訊安全專家所執行。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: ' ',
          size: 24,
        }),
      ],
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '本次的社交工程郵件演練服務測試出所有截至本文件產出前已知的相關資訊。隨著新的社交工程郵件威脅持續產生，建議定期執行社交工程郵件演練，並且維持每年檢測1-2次的頻率。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: ' ',
          size: 24,
        }),
      ],
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '關於本文件',
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Table({
      columnWidths: [tableWidthDxa / 2, tableWidthDxa / 2],
      width: { size: tableWidthDxa, type: WidthType.DXA },
      rows: [
        Row({
          label: [
            new TextRun({
              text: '文件類別',
              bold: true,
              font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
              size: 24,
            }),
          ],
          value: [
            new TextRun({ text: '                         ', size: 24 }),
            new TextRun({
              text: '社交工程',
              font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
              size: 24,
            }),
            new TextRun({
              text: service,
              font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
              size: 24,
            }),
            new TextRun({
              text: '測試服務結果及分析報告書',
              font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
              size: 24,
            }),
          ],
          color: COLOR.secondary_60,
        }),
        Row({
          label: [
            new TextRun({
              text: '客戶',
              bold: true,
              font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
              size: 24,
            }),
          ],
          value: [
            new TextRun({ text: '                         ', size: 24 }),
            new TextRun({
              text: companyName,

              font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
              size: 24,
            }),
          ],
        }),
        Row({
          label: [
            new TextRun({
              text: '執行顧問',
              bold: true,
              font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
              size: 24,
            }),
          ],
          value: [
            new TextRun({ text: '                         ', size: 24 }),
            new TextRun({
              text: secondaryCompanyFullname,
              font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
              size: 24,
            }),
          ],
          color: COLOR.secondary_60,
        }),
        Row({
          label: [
            new TextRun({
              text: '文件版本',
              bold: true,
              font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
              size: 24,
            }),
          ],
          value: [
            new TextRun({ text: '                         ', size: 24 }),
            new TextRun({
              text: version,
              font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
              size: 24,
            }),
          ],
        }),
        Row({
          label: [
            new TextRun({
              text: '製作日期',
              bold: true,
              font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
              size: 24,
            }),
          ],
          value: [
            new TextRun({ text: '                         ', size: 24 }),
            new TextRun({
              text: `${parseDateToTaiwanDate(generateStartDate)} - ${parseDateToTaiwanDate(
                generateEndDate,
              )}`,
              font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
              size: 24,
            }),
          ],
          color: COLOR.secondary_60,
        }),
      ],
    }),
  ]
}

export default DisclaimerPage
